import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { useEditSalesRateMutation } from "../../../features/api/salesratemainApi";
import { API_BASE_URL } from "../../../components/baseUrl";

const UpdateSalesRate = ({ passData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };
  const { row, proName } = passData;

  const [salesRate, setSalesRate] = useState(0);
  const [unitPrice, setUnitRate] = useState(0);
  const [date, setDate] = useState(new Date());

  const [updateSalesRate] = useEditSalesRateMutation();
  const handleUpdate = async () => {
    try {
      const data = {
        id: row?.id,
        sales_rate: salesRate ? salesRate : row?.sales_rate,
        unit_price: unitPrice ? unitPrice : row?.unit_price,
      };
      const repeatData = {
        name: row?.pro_name,
        unit_price: row?.unit_price,
        sales_price: salesRate ? salesRate : row?.salesRate,
        addDate: date,
      };

      const response = await updateSalesRate(data);
      const res = await axios.post(
        `${API_BASE_URL}/api/sales`,
        repeatData
      );
      if (response) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-6">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">New Sales Rate</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex justify-between">
                      <label className="font-bold">Date:</label>
                      <DateTimePicker
                        value={date}
                        onChange={setDate}
                        className=" h-8"
                      />
                    </div>
                    <div className="flex justify-between">
                      <h1 className="">
                        <span className="font-bold">Product:</span>{" "}
                        {proName?.product_name}
                      </h1>
                    </div>
                    <div className="flex justify-between">
                      <label className="font-bold">Purchase Rate:</label>
                      <input
                        type="text"
                        onChange={(e) => setUnitRate(e.target.value)}
                        defaultValue={row?.unit_price}
                        className="border pl-1"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="font-bold">Sales Rate:</label>
                      <input
                        type="text"
                        defaultValue={row?.sales_rate}
                        onChange={(e) => setSalesRate(e.target.value)}
                        className={`border pl-1 `}
                      />
                    </div>
                  </div>
                  <button
                    disabled={date === ""}
                    onClick={() => handleUpdate()}
                    className="bg-green-500 text-white font-bold mt-6 px-4 block m-auto"
                  >
                    Added
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateSalesRate;
